import * as types from './types';
import { NotificationsAction } from './types';
import { NotificationInfo, NotificationsState } from './state';

const initialNotificationsState = {
    sysa: [],
    info: null,
    isCustom: false
};

export function notificationReducer(
    notifications: NotificationsState = initialNotificationsState,
    action: NotificationsAction
): NotificationsState {
    switch (action.type) {
        case types.ADD_NOTIFICATION: {
            const newSysa = action.payload;
            const newNotifications = [...notifications.sysa, newSysa];
            return { ...notifications, sysa: newNotifications };
        }
        case types.REMOVE_NOTIFICATION: {
            const index = notifications.sysa.findIndex(item => {
                return item.id === action.payload;
            });
            if (index < 0) {
                return notifications;
            } else {
                const reducedNotifications = [
                    ...notifications.sysa.slice(0, index),
                    ...notifications.sysa.slice(index + 1)
                ];
                return { ...notifications, sysa: reducedNotifications };
            }
        }
        case types.SHOW_NOTIFICATION_INFO: {
            const notification = action.payload as NotificationInfo;
            return { ...notifications, info: { ...notification } };
        }
        case types.REMOVE_NOTIFICATION_INFO:
            return { ...notifications, info: null };

        default:
            return notifications;
    }
}
